import { ReactNode } from 'react';

import { Stack } from '@mui/material';

import Spinner from '../Spinner';
import useMetadataFetcher from './vm';

export interface MetadataFetcherProps {
  children: ReactNode;
}

const MetadataFetcher = ({ children }: MetadataFetcherProps) => {
  const { isFetchingMetadata } = useMetadataFetcher();

  if (isFetchingMetadata) {
    return (
      <Stack height="100%" justifyContent="center" alignItems="center">
        <Spinner size="xLarge" />
        loading
      </Stack>
    );
  }

  return <>{children}</>;
};

export default MetadataFetcher;
